(function( $ ) {
	var isMobile = function(){
		if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
			return true;
		}else{
			return false;
		}
	}
	var getUrlParameter = function getUrlParameter(sParam) {
	    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
	        sURLVariables = sPageURL.split('&'),
	        sParameterName,
	        i;

	    for (i = 0; i < sURLVariables.length; i++) {
	        sParameterName = sURLVariables[i].split('=');

	        if (sParameterName[0] === sParam) {
	            return sParameterName[1] === undefined ? true : sParameterName[1];
	        }
	    }
	};
	var sowgood = function(){
		var scrollEvent = function(){
			var _h = $(window).height();
			var _scorllVal = 0;
			var _lastScrollTop = 0;
			var _anchorMenu = $('.anchorWrapper');
			if(_anchorMenu.length == 1){
				var _anchorMenuOffset = $('.anchorWrapper').offset().top + 40;
				$(window).bind('scroll', function() {
					var scrollTop = $(window).scrollTop();
					console.log(_anchorMenuOffset);
			      		//console.log( scrollTop + "|" + _h + "|" + _blur);
			      	if(scrollTop > _anchorMenuOffset){
			      		_anchorMenu.addClass("fixed")
			      	}else{
			      		_anchorMenu.removeClass("fixed")
			      	}
			    });
			}

		}
		var scrollUpEvent = function(){
			if(isMobile){
				var position = $(window).scrollTop(); 
				var _h = $(window).height();
				$(window).scroll(function() {
				    var scroll = $(window).scrollTop();
				    if(scroll > position || scroll < _h) {
				        // console.log('scrollDown');
				         $('.dropdownAnchorWrapper').removeClass('fixed')
				    } else {
				        // console.log('scrollUp');
				        $('.dropdownAnchorWrapper').addClass('fixed')
				    }
				    position = scroll;
				});
			}
		}
		var dorpdownAnchorEvent = function(){
			if($('#dropdownAnchorWrapper')){
				$('#dropdownAnchorWrapper').on('hidden.bs.dropdown', function () {
					
	      		});
				var _initText = $('.anchorWrapper').find('a span').eq(0).html();
				$('#dropdownAnchorWrapper').find('.dropdown-toggle').html(_initText);

				$('#dropdownAnchorWrapper').each(function(){
					var _this = $(this);
					_this.find('.dropdown-menu a').click(function(){
			   	 		var _text = $(this).html();
			   	 		_this.find('.dropdown-toggle ').html(_text);
			   	 		var _target = $(this).attr("data-href");
						$("html, body").animate({ scrollTop: $("#" + _target).offset().top + 10}, 500);
			  		});
				})
	      	}
		}
		var anchorEvent = function(){
			if($(".anchorWrapper").length == 1){
				$(".anchorWrapper a").click(function (event) {
					event.preventDefault();
					var _target = $(this).attr("data-href");
					$("html, body").animate({ scrollTop: $("#" + _target).offset().top - 50 }, 500);
				});
			}
		}
		var movingBanner = function(){
			
		}
		var mobileSubCate = function(){
			if($('.mobile-sub-cate-wrapper .swiper-container')){
				var mobileSubCateSwiper = new Swiper ('.mobile-sub-cate-wrapper .swiper-container', {
					spaceBetween: 0,
					loop: false,
			        slidesPerView: 'auto',
		    	})
	    	}
		}
		var languageSwitch = function(){
			// var languageIcons = $('#language-icons');
			// var _url = window.location.pathname;

			// if(languageIcons.hasClass('en')){
			// 	_url = _url.replace('_en.html','');
			// 	_url = _url + ".html";
			// }else{
			// 	_url = _url.replace('.html','');
			// 	_url = _url + "_en.html";
			// }
			// languageIcons.find('a').attr('href', _url);
		}
		var navInit = function(){
			var hamburger = $('#hamburger');
			var hamburgeClose = $('#hamburger-border');
			var wrapperMenu = $('.wrapper-menu.open');
			var wrapperCloseMenu = $('.wrapper-menu.close');
			topMenu = $('#menu-wrapper');
			hamburger.click(function(){
				if(wrapperMenu.attr('aria-expanded') == 'false'){
					wrapperMenu.attr('aria-expanded','true')
					topMenu.attr('aria-expanded','true')
				}else{
					wrapperMenu.attr('aria-expanded','false')
					topMenu.attr('aria-expanded','false')
				}
				$('body').addClass('menu-open');
			})
			hamburgeClose.click(function(){
				if(wrapperCloseMenu.attr('aria-expanded') == 'false'){
					wrapperMenu.attr('aria-expanded','false')
					topMenu.attr('aria-expanded','false')
					wrapperMenu.attr('aria-expanded','false')
				}else{
					wrapperCloseMenu.attr('aria-expanded','true')
					topMenu.attr('aria-expanded','true')
					wrapperMenu.attr('aria-expanded','true')
				}
				$('body').removeClass('menu-open');
			})

		}
		var footerLinks = function(){
			var _fbc = $('.link-fb-clone').find('p a').attr('href');
			var _igc = $('.link-ig-clone').find('p a').attr('href');
			var _l1c = $('.link-logo-sjs-clone').find('p a').attr('href');
			var _l2c = $('.link-logo-foundation-clone').find('p a').attr('href');

			$('.link-fb').attr('href' ,_fbc );
			$('.link-ig').attr('href' ,_igc )
			$('.link-logo-sjs').attr('href' ,_l1c )
			$('.link-logo-foundation').attr('href' ,_l2c )
		}
		var init = function(){
			navInit();
			mobileSubCate();
			scrollEvent();
			anchorEvent();
			dorpdownAnchorEvent();
			scrollUpEvent();
			languageSwitch();
			footerLinks();
			
		}
		return {
			init : init
		}
	}
	
	$( document ).ready( function() {
		var Sowgood = new sowgood();
		Sowgood.init();

		new WOW().init();



	});

})( jQuery );



